import { Component, OnInit } from '@angular/core';
import { GenericService } from '../services/generic.service';
import {ActivatedRoute } from '@angular/router';
import { SplashScreenStateService } from '../services/splash-screen-state-service';
// import { SplashScreenStateService } from '../services/splash-screen-state-service';
@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.css']
})
export class BlogComponent  implements OnInit {
  public theHtmlString ="";
  retItem: any;
  retItems: any;
  cat: any;

  constructor(private genericService: GenericService, private route: ActivatedRoute,private splashScreenStateService: SplashScreenStateService)
   { 

  }



  ngOnInit() {



    this.route.params.subscribe( params => {console.log(params);
if(params.catId){
  setTimeout(() => {
    this.splashScreenStateService.stop();
    
 }, 500);

  this.GetPosts(params.catId);
}
else{
  setTimeout(() => {
    this.splashScreenStateService.stop();
    
 }, 500);

this.GetPostById(params.id);



}
          
    });

  }



  GetPosts(catId:number) {
    
    this.genericService.getPosts(catId).subscribe((data) => {
      this.retItems = data;
      this.cat = this.retItems[0].catId;
     this.splashScreenStateService.stop();
      // console.log(this.retItem);
    }),
    err => {
       console.log(err);
    }
}
GetPostById(id:number) {
    
  this.genericService.getPostById(id).subscribe((data) => {
    this.retItems = data;
    this.splashScreenStateService.stop();
    // console.log(this.retItem);
  }),
  err => {
     console.log(err);
  }
}
}

